export default function loadLocale(locale) {
  return new Promise((resolve) => {
    switch (locale) {
      case 'de-DE': {
        require.ensure(['./de-DE'], (require) => {
          const data = require('./de-DE');
          resolve(data.__esModule === true ? data.default : data);
        }, 'de-DE');
        break;
      }
      case 'en-CA': {
        require.ensure(['./en-CA'], (require) => {
          const data = require('./en-CA');
          resolve(data.__esModule === true ? data.default : data);
        }, 'en-CA');
        break;
      }
      case 'en-GB': {
        require.ensure(['./en-GB'], (require) => {
          const data = require('./en-GB');
          resolve(data.__esModule === true ? data.default : data);
        }, 'en-GB');
        break;
      }
      case 'en-US': {
        require.ensure(['./en-US'], (require) => {
          const data = require('./en-US');
          resolve(data.__esModule === true ? data.default : data);
        }, 'en-US');
        break;
      }
      case 'es-419': {
        require.ensure(['./es-419'], (require) => {
          const data = require('./es-419');
          resolve(data.__esModule === true ? data.default : data);
        }, 'es-419');
        break;
      }
      case 'es-ES': {
        require.ensure(['./es-ES'], (require) => {
          const data = require('./es-ES');
          resolve(data.__esModule === true ? data.default : data);
        }, 'es-ES');
        break;
      }
      case 'fr-CA': {
        require.ensure(['./fr-CA'], (require) => {
          const data = require('./fr-CA');
          resolve(data.__esModule === true ? data.default : data);
        }, 'fr-CA');
        break;
      }
      case 'fr-FR': {
        require.ensure(['./fr-FR'], (require) => {
          const data = require('./fr-FR');
          resolve(data.__esModule === true ? data.default : data);
        }, 'fr-FR');
        break;
      }
      case 'it-IT': {
        require.ensure(['./it-IT'], (require) => {
          const data = require('./it-IT');
          resolve(data.__esModule === true ? data.default : data);
        }, 'it-IT');
        break;
      }
      default:
        resolve({});
        break;
    }
  });
}
